const rootUrl =
  process.env.NODE_ENV === "production" ? "https://dialin.mynew.jobs/api" : "";

export default rootUrl;
